const OPTION_CATEGORY = [
  {
    label: "Bantuan",
    value: "BANTUAN",
  },
  {
    label: "Apps",
    value: "APPS",
  },
];

const OPTION_TOPIC_HELP = [
  {
    label: "Jenis Pengiriman & Layanan",
    value: "Produk",
  },
  {
    label: "Pelacakan Paket",
    value: "pelacakan-paket",
  },
  {
    label: "Cek Tarif",
    value: "cek-tarif",
  },
  {
    label: "Pengemasan Paket",
    value: "Pengemasan",
  },
  {
    label: "Pembayaran",
    value: "pembayaran",
  },
  {
    label: "Asuransi",
    value: "asuransi",
  },
  {
    label: "Klaim Paket",
    value: "klaim-paket",
  },
  {
    label: "Agen",
    value: "Keagenan",
  },
  {
    label: "Korporasi",
    value: "korporasi",
  },
  {
    label: "Dangerous Goods",
    value: "dangerous-goods",
  },
  {
    label: "Cash On Delivery",
    value: "cash-on-delivery",
  },
];

const OPTION_TOPIC_APPS = [
  {
    label: "Pick Up",
    value: "pick-up",
  },
  {
    label: "Drop Paket",
    value: "drop-paket",
  },
  {
    label: "Cek Tarif",
    value: "cek-tarif",
  },
  {
    label: "Klaim Paket",
    value: "klaim-paket",
  },
  {
    label: "Poin & Saldo",
    value: "poin-&-saldo",
  },
  {
    label: "Membership",
    value: "membership",
  },
  {
    label: "Paketmu",
    value: "paketmu",
  },
  {
    label: "Pembayaran",
    value: "pembayaran",
  },
  {
    label: "Akun",
    value: "akun",
  },
];

const ALL_OPTIONS = {
  BANTUAN: OPTION_TOPIC_HELP,
  APPS: OPTION_TOPIC_APPS,
};

module.exports = {
  OPTION_CATEGORY,
  OPTION_TOPIC_HELP,
  OPTION_TOPIC_APPS,
  ALL_OPTIONS,
};
